import { render, staticRenderFns } from "./noticeView.vue?vue&type=template&id=02f922cf&scoped=true&"
import script from "./noticeView.vue?vue&type=script&lang=js&"
export * from "./noticeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f922cf",
  null
  
)

export default component.exports